import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { LockOutlined, UnlockOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, Button, Row, Col } from 'antd';
import { FormattedMessage } from 'react-intl';
import { GlobalConfigContext } from '../../components/Config/GlobalConfigContext';
import * as authActions from '../../actions/auth';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
//import api from '../../middleware/api';
import "./login.css";
import "../../stylesheets/App.forms.scss";
import logoFull from '../../native_laboratoire_logo.svg';
import Notifications from "../../components/Notifications";

const FormItem = Form.Item;

class PasswordResetForm extends React.PureComponent {
	static contextType = GlobalConfigContext;
	constructor(props) {
		super(props);
		this.state = {
			isAuthenticating: false,
			passwordError: false
		}
    }
    // componentDidUpdate = (prevProps) => {
    //     if(prevProps.isAuthenticating && !this.props.isAuthenticating){
            
    //     }
	// }
	checkSamePassword = (e, index) => {
		let p2 = e.target.value;
		let p1;
		if (index === 1) {
			p1 = this.props.form.getFieldValue('password2');
		} else {
			p1 = this.props.form.getFieldValue('password');
		}

		if (p1 === p2) {
			this.setState({
				passwordError: false
			});
		}
		else {
			this.setState({
				passwordError: true
			});
		}
	}
	handleSubmit = (e) => {
        e.preventDefault();
        const queryParams = queryString.parse(this.props.location.search ? this.props.location.search : null)
        console.log(`queryParams:`, queryParams);
	    this.props.form.validateFields((err, values) => {
			if (!err) {
				/** 
				 * **email or user id should pass with token!**
				 */
				// const { dispatch } = this.props;
				// const updatedUser = dispatch(authActions.reset_password({ /* id: token.id, email: token.email, */ password: values.password }));
				// updatedUser.then(() => {
				// 	if (!updatedUser.success) {
				// 		this.context.notifications.notify({
				// 			title: this.context.intl.formatMessage({ id: 'login.actions.notification.error.title', defaultMessage: 'Password reset failed!' }),
				// 			message: this.props.loginError,
				// 			type: 'notification',
				// 			kind: 'error'
				// 		});
				// 	}
				// 	const login = dispatch(authActions.login({email: updatedUser.data.email, password: updatedUser.data.password }));
				// 	login.then(() => {
				// 		if (this.props.loginError) {
				// 			this.context.notifications.notify({
				// 				title: this.context.intl.formatMessage({ id: 'login.actions.notification.error.title', defaultMessage: 'Login failed!' }),
				// 				message: this.props.loginError,
				// 				type: 'notification',
				// 				kind: 'error'
				// 			});
				// 		}
				// 	});
				// })
			}
	    });
	}

  	render() {
        const { loginError, isAuthenticating } = this.props;
		const { getFieldDecorator } = this.props.form;
		
        return (
            <Row type="flex" align="middle" justify="center" gutter={4} className="login-wrapper">
                <Col xs={24} md={12} lg={16} xl={18} className="bg-pic">
                    <img src={'/assets/login-bg.svg'} alt="Logo" />
                    <div className="bg-caption">
                        <h2 className="semi-bold text-white"><FormattedMessage id="login.hotelizer" defaultMessage={`Hotelizer: your hotel organizer`} /></h2>
                        <p className="small"><FormattedMessage id="login.hotelizer.details" defaultMessage={`All you have in your mind for your hotel, you can now find in one place, using a new web application. Designed to work for you and your team, using your favourite device, wherever you are.`} /></p>
                    </div>
                </Col>
                <Col xs={24} md={12} lg={8} xl={6} className="login-container">
                    {loginError && <Notifications />}
                    <Form layout="vertical" onSubmit={this.handleSubmit} className="pms-form">
                    
                    <div className="logo">
                        <img src={logoFull} alt="Logo" />
                    </div>
                    

						<p><FormattedMessage id="login.hotelizer.sign-in" defaultMessage={`Reset password. Enter a new password for your account.`} /></p>

						<FormItem label={<FormattedMessage id="login.form.reset.password" defaultMessage={`New password`} />} validateStatus={this.state.passwordError ? 'error' : ''}>
							{getFieldDecorator('password', {
								rules: [{ required: true, message: this.context.intl.formatMessage({ id: 'login.form.password.message', defaultMessage: 'Please input your password!' }) }],
								onChange: (e) => this.checkSamePassword(e, 1)
							})(
								<Input prefix={<LockOutlined style={{ fontSize: 14 }} />} type="password" />
							)}
						</FormItem>

						<FormItem label={<FormattedMessage id="login.form.reset.password" defaultMessage={`Repeat password`} />} hasFeedback validateStatus={this.state.passwordError ? 'error' : ''}>
							{getFieldDecorator('password2', {
								rules: [{ required: true, message: this.context.intl.formatMessage({ id: 'login.form.password.message', defaultMessage: 'Please input your password!' }) }],
								onChange: (e) => this.checkSamePassword(e, 2)
							})(
								<Input prefix={<LockOutlined style={{ fontSize: 14 }} />} type="password" />
							)}
						</FormItem>

						<Button type="primary" htmlType="submit" className="login-form-button" loading={isAuthenticating} icon={<UnlockOutlined />}>
							<FormattedMessage id="login.reset" defaultMessage={`Reset Password`} />
						</Button>
			
						
                    </Form>

                </Col>
                
            </Row>
        );
    }
}

PasswordResetForm.propTypes = {
	dispatch: PropTypes.func.isRequired,
	form: PropTypes.object.isRequired,
	//isAuthenticating: PropTypes.bool
}

function mapStateToProps(state) {
	const { auth } = state;
	if (auth) {
	    return { user: auth.user, loginError: auth.errorMessage, isAuthenticating: auth.isAuthenticating };
	}

	return { user: null };
}

const WrappedPasswordResetForm = Form.create()(PasswordResetForm);

const mapDispatchToProps = dispatch => ({
	authActions: bindActionCreators(authActions, dispatch),
	dispatch
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WrappedPasswordResetForm));
  